import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function PageHead({ kicker, title, sub }) {
  return (
    <div className="mx-auto max-w-[1600px] px-6 pb-12 pt-32 sm:pt-36">
      <motion.p
        initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}
        className="font-mono2 text-[11px] tracking-[0.35em] text-amber-500"
      >
        {kicker}
      </motion.p>
      <h1 className="font-display mt-3 text-4xl uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl" data-testid="page-title">
        <span className="mask-line"><motion.span initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}>{title}</motion.span></span>
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.35 }}
          className="font-serif-it mt-4 max-w-2xl text-lg italic text-slate-400"
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
}
